// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modal-module--modalContainer--2qu70","modal":"modal-module--modal--P4bnk","sendBtn":"modal-module--sendBtn--2Gkkz","closeBtn":"modal-module--closeBtn--1dUUw"};